// @ts-nocheck
import _ from 'lodash';
import moment from 'moment';
import { from, Observable } from 'rxjs';
export class Orders {
  constructor(
    BaseService,
    $filter,
    $timeout,
    $rootScope,
    toastr,
    ngDialog,
    MedicationService,
    Constants,
    localStorageService,
    Users,
    ENV,
    serverless_api_url,
  ) {
    'ngInject';

    Object.assign(this, {
      $filter,
      $timeout,
      $rootScope,
      toastr,
      ngDialog,
      ...BaseService,
      MedicationService,
      Constants,
      localStorageService,
      serverless_api_url,
      Users,
      ENV,
      /* eslint-disable no-use-before-define */
      STATUSES,
      STATUS,
      // Defined at bottom of file
      TASKS,
      TOTALFILLS,
      /* eslint-enable no-use-before-define */
    });

    var this2 = this;
    this.checkAll = function (admin_status) {
      return admin_status.status === Constants.AdminStatuses.All.NumericValue;
    };
    this.checkLabOrderSent = function (admin_status) {
      return admin_status.status === Constants.AdminStatuses.LabOrderSent.NumericValue;
    };
    this.BODACDC_625 = FEATURE_BODACDC_625;
  }
  callSlackToNotify(prescription, parameters, visit) {
    // 12/16/2021: we will disable this at the moment for UK prescriptions.

    return;
    this.Users.getStaffUser(prescription.prescribed_by)
      .then(({ data }) => {
        var name;
        var initials;
        var textMessage = '';
        var username = '';
        var myKeyVals;
        if (parameters.dollar_sign) textMessage = ':heavy_dollar_sign: ';
        if (parameters.pill_sign) textMessage = ':pill: ';

        // For prescribe tab
        if (parameters.new_prescription) {
          name = visit.user.firstname + ' ' + visit.user.lastname;
          initials = name.match(/\b\w/g) || [];
          initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
          textMessage += visit.id + ' ' + initials + ' - ' + prescription.name + ' ' + visit.user.state;

          // For mailorder tab
        } else {
          name = visit.user.firstname + ' ' + visit.user.lastname;
          initials = name.match(/\b\w/g) || [];
          initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
          textMessage +=
            visit.id + ' ' + initials + ' - ' + 'Refill request sent to ' + prescription.mail_order.partner_code;
        }
        if (parameters.show_prescriber) {
          if (data.title) {
            username = data.title + ' ' + data.firstname + ' ' + data.lastname;
          } else {
            username = data.firstname + ' ' + data.lastname;
          }
        } else {
          username = 'Refill Automation';
        }
        if (parameters.include_icon_url) {
          myKeyVals = JSON.stringify({
            username: username,
            text: textMessage,
            icon_url: 'https://slack.com/img/icons/app-57.png',
          });
        } else {
          myKeyVals = JSON.stringify({
            username: username,
            text: textMessage,
          });
        }
        this.slackNotification(myKeyVals, this.ENV, prescription.mail_order.partner_code)
          .then(dataRespond => {
            console.log('Slack sent');
          })
          .catch(err => {
            console.log(err);
          });
      })
      .catch(err => {});
  }
  hasTreatmentPlansNotSent(visit) {
    var hasTreatmentPlansNotSent = false;
    if (visit.admin_status === 10 && visit.prescriptions && visit.prescriptions.length) {
      visit.prescriptions.forEach(prescription => {
        if (prescription.sent && !prescription.treatment_plan_sent) hasTreatmentPlansNotSent = true;
      });
    }
    return hasTreatmentPlansNotSent;
  }
  showTreatmentPlanPopup(visit) {
    this.openTreatmentPlanForm(visit, response => {
      if (response && response.success) {
        // Treatment plan sent
        this.$rootScope.$broadcast('visit:refresh');

        // WE UNLOCK THE VISIT IF USER CONFIRMS TREATMENT PLAN POPUP
        // this.unlock()
        // .finally(() => {

        //   // We refresh the visit, so some buttons can dissapear
        //   this.$rootScope.$broadcast('visit:refresh');
        // });
      } else {
        // WE ALSO UNLOCK THE VISIT IF USER CANCELS OR CLOSES TREATMENT PLAN POPUP
        // this.unlock()
        // .finally(() => {
        //   // We refresh the visit, so some buttons can dissapear
        //   this.$rootScope.$broadcast('visit:refresh');
        // });
      }
    });
  }
  openTreatmentPlanForm(order, callback) {
    return this.ngDialog.open({
      template: 'app/components/treatment-plan-form/treatment-plan-form.html',
      // To not allow the user closes the modal without explicitely to have some action

      // showClose: false,
      closeByEscape: false,
      closeByNavigation: false,
      closeByDocument: false,
      controller: 'TreatmentPlanFormController',
      controllerAs: '$ctrl',
      className: 'ngdialog-theme-default treatment-plan-form-modal',
      data: {
        order: order,
      },
      /**
       * @param {string|object} res - res will be an object if a pharmacy is selected
       */
      preCloseCallback(res) {
        if (typeof res === 'object') {
          return callback(res);
        }
        return callback(false);
      },
    });
  }

  /*
   * Check if there is only one mailorder refill open and close it
   * If there are more than one open, then we do not do nothing and
   * we show an error message
   */

  // Num fill requests open = 0 => OK
  // Num fill requests open = 1 => OK (if successful API call) / ERROR (if failed API call)
  // Num fill requests open > 1 => ERROR

  closeOpenMailorderRefill(visitId, newMailorderPrescriptionsId) {
    return new Promise((resolve, reject) => {
      this.getMailOrderDetails(visitId)
        .then(({ data }) => {
          var prescriptionArray = data;
          var newMailOrderPrescriptions = [];
          prescriptionArray = prescriptionArray.filter(v => v.mail_order);
          prescriptionArray.forEach(prescription => {
            newMailorderPrescriptionsId.forEach(prescriptionId => {
              if (prescription.mail_order.order_line_medication_id === prescriptionId) {
                newMailOrderPrescriptions.push(prescription);
              }
            });
          });
          if (!newMailOrderPrescriptions.length) resolve(0);
          var numOpenFillRequests = 0;
          var openFillRequest = null;
          newMailOrderPrescriptions.forEach(prescription => {
            if (
              prescription.mail_order &&
              prescription.mail_order.fill_requests &&
              prescription.mail_order.fill_requests.length
            ) {
              prescription.mail_order.fill_requests.forEach(fillRequest => {
                if (!fillRequest.sent) {
                  numOpenFillRequests++;
                  openFillRequest = fillRequest;
                  openFillRequest.mail_order_id = prescription.mail_order.id;
                }
              });
            }
          });
          if (!numOpenFillRequests) resolve(0);
          if (numOpenFillRequests > 1) reject('Error, there are more than one Fill Request open');
          if (numOpenFillRequests === 1) {
            this.reprocessFillRequest(openFillRequest.mail_order_id, openFillRequest.id, false, true)
              .then(({ data }) => {
                //Refill request processed successfully
                resolve(1);
              })
              .catch(err => {
                reject('Error updating Fill Request: ' + JSON.stringify(err));
              });
          } else {
            reject('Error');
          }
        })
        .catch(err => {
          reject('Error getting mailorder prescriptions: ' + JSON.stringify(err));
        });
    });
  }

  // If visit is pickup => true
  // Otherwise => false
  isFulfilmentTypePickupOnly(fulfilment_type) {
    if (fulfilment_type === 0) return true;
    return false;
  }

  // If visit is mailorder one time or monthly => true
  // If visit is pickup or hybrid => false
  isFulfilmentTypeMailorderOnly(fulfilment_type) {
    if (fulfilment_type === 1 || fulfilment_type === 2) return true;
    return false;
  }
  getFulfilmentType(pharmacyOption) {
    if (pharmacyOption && pharmacyOption.fulfilment_type) {
      return pharmacyOption.fulfilment_type;
    } else {
      // If there is no fulfilment type in the order
      // Default will be zero
      return 0;
    }
  }
  getMedicationDispenseAmount(visit) {
    var medicationDispenseAmount = null;
    if (!visit) return null;
    if (!visit.prescriptions || visit.prescriptions.length < 1) return null;
    visit.prescriptions.forEach(prescription => {
      if (prescription.pharmacy && prescription.pharmacy.mailorder_partner) {
        medicationDispenseAmount = prescription.dispense_amount;
      }
    });
    if (medicationDispenseAmount) {
      if (typeof medicationDispenseAmount === 'string') {
        return parseInt(medicationDispenseAmount);
      }
      if (typeof medicationDispenseAmount === 'number') {
        return medicationDispenseAmount;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  setCurrentVisit(visit, currentUser) {
    this.current = new Order(visit, currentUser);
    return this.current;
  }
  search(pagination, includeFlagged, polling, start_time_date_object, end_time_date_object) {
    // Create a clone so we aren't modifying the pagination object associated with the view
    const query = Object.assign({}, pagination);
    if (includeFlagged) {
      if (!query.hasOwnProperty('include_all_blocked')) {
        query.include_all_blocked = true;
      }
    }
    if (polling) {
      query.polling = true;
    }

    // TO SOLVE DATE OBJECT CACHE PROBLEM
    query.start_time =
      start_time_date_object && _.isDate(start_time_date_object)
        ? moment(start_time_date_object).toISOString()
        : undefined;
    query.end_time =
      end_time_date_object && _.isDate(end_time_date_object) ? moment(end_time_date_object).toISOString() : undefined;

    // We need to add a day to endtime so we get all orders for the day selected
    if (query.end_time) {
      query.end_time = moment(query.end_time).add(1, 'day').toISOString();
    }

    // Pipe delimit admin statuses for URL encoding
    if (_.isArray(query.admin_status) && query.admin_status.length) {
      query.admin_status = query.admin_status.map(s => (typeof s === 'object' ? s.status : s)).join('|');
    } else {
      if (typeof query.admin_status !== 'string') {
        delete query.admin_status;
      }
    }

    if (_.isArray(query.medication_ids) && query.medication_ids.length) {
      query.medication_ids = query.medication_ids
        .map(medication => (typeof medication === 'object' ? medication.id : medication))
        .join('|');
    } else {
      if (typeof query.medication_ids !== 'string') {
        delete query.medication_ids;
      }
    }

    // Pipe delimit states for URL encoding
    if (_.isArray(query.state) && query.state.length) {
      query.state = query.state.map(s => (typeof s === 'object' ? s.code : s)).join('|');
    } else {
      if (typeof query.state !== 'string') {
        delete query.state;
      }
    }

    // Pipe delimit categories for URL encoding
    if (_.isArray(query.category_code) && query.category_code.length) {
      query.category_code = query.category_code.map(s => (typeof s === 'object' ? s.category : s)).join('|');
    } else {
      if (typeof query.category_code !== 'string') {
        delete query.category_code;
      }
    }

    // FOR PARTNER PARAMETER
    if (query.partner === 'all') {
      delete query['partner'];
    }

    // FOR VISIT TYPE PARAMETER
    if (query.is_slv === 'all') {
      delete query['is_slv'];
    }

    query.is_batchable = false;

    // sanitize keys used for UI only
    ['total', 'current'].forEach(key => {
      if (key in query) {
        delete query[key];
      }
    });
    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(`${this.API_URL}/admin/orders${queryString}`, {
      loadingText: 'Loading Visits',
    });
  }

  searchCancelledOrders(pagination, start_time_date_object, end_time_date_object) {
    // Create a clone so we aren't modifying the pagination object associated with the view
    const query = Object.assign({}, pagination);

    // Pipe delimit categories for URL encoding
    if (_.isArray(query.service_code) && query.service_code.length) {
      query.service_code = query.service_code.map(s => (typeof s === 'object' ? s.category : s)).join('|');
    } else {
      if (typeof query.service_code !== 'string') {
        delete query.service_code;
      }
    }

    // Pipe delimit dispensing statuses for URL encoding
    if (_.isArray(query.dispensing_status) && query.dispensing_status.length) {
      query.dispensing_status = query.dispensing_status
        .map(s => (typeof s === 'object' ? s.dispensing_status : s))
        .join('|');
    } else {
      if (typeof query.dispensing_status !== 'string') {
        delete query.dispensing_status;
      }
    }

    // Pipe delimit pst statuses for URL encoding
    if (_.isArray(query.pst_status) && query.pst_status.length) {
      query.pst_status = query.pst_status.map(s => (typeof s === 'object' ? s.pst_status : s)).join('|');
    } else {
      if (typeof query.pst_status !== 'string') {
        delete query.pst_status;
      }
    }

    // TO SOLVE DATE OBJECT CACHE PROBLEM
    query.start_time =
      start_time_date_object && _.isDate(start_time_date_object)
        ? moment(start_time_date_object).toISOString()
        : undefined;
    query.end_time =
      end_time_date_object && _.isDate(end_time_date_object) ? moment(end_time_date_object).toISOString() : undefined;

    // We need to add a day to endtime so we get all orders for the day selected
    if (query.end_time) {
      query.end_time = moment(query.end_time).add(1, 'day').toISOString();
    }

    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(`${this.Endpoints.cancelledOrders.orders}${queryString}`, {
      loadingText: 'Loading Visits',
    });
  }
  getCancelledOrdersStatuses() {
    return this.$http.get(this.Endpoints.cancelledOrders.statuses);
  }
  changeStoreOrder(order_id, dispense_order_id, payload) {
    return this.$http.put(
      this.Endpoints.cancelledOrders.updateOrder
        .replace(':order_id', order_id)
        .replace(':dispense_order_id', dispense_order_id),
      payload,
    );
  }
  getStores() {
    return this.$http.get(this.Endpoints.cancelledOrders.stores);
  }
  searchAppointments(pagination) {
    // Create a clone so we aren't modifying the pagination object associated with the view
    const query = Object.assign({}, pagination);

    // Pipe delimit states for URL encoding
    if (_.isArray(query.state) && query.state.length) {
      query.state = query.state.map(s => (typeof s === 'object' ? s.code : s)).join('|');
    } else {
      if (typeof query.state !== 'string') {
        delete query.state;
      }
    }

    // sanitize keys used for UI only
    ['total', 'current'].forEach(key => {
      if (key in query) {
        delete query[key];
      }
    });
    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(`${this.API_URL}/admin/scheduledorders${queryString}`, {
      loadingText: 'Loading Visits',
    });
  }
  searchVisitHistory(pagination) {
    // Create a clone so we aren't modifying the pagination object associated with the view
    const query = Object.assign({}, pagination);
    query.start_time = _.isDate(query.start_time) ? moment(query.start_time).toISOString() : undefined;

    // We need to add a day to endtime so we get all orders for the day selected
    query.end_time = _.isDate(query.end_time) ? moment(query.end_time).add(1, 'day').toISOString() : undefined;

    // Pipe delimit clinicians for URL encoding
    if (_.isArray(query.staff_user_id) && query.staff_user_id.length) {
      query.staff_user_id = query.staff_user_id.map(s => (typeof s === 'object' ? s.staff_user_id : s)).join('|');
    } else {
      if (typeof query.staff_user_id !== 'string') {
        delete query.staff_user_id;
      }
    }

    // Pipe delimit states for URL encoding
    if (_.isArray(query.state) && query.state.length) {
      query.state = query.state.map(s => (typeof s === 'object' ? s.code : s)).join('|');
    } else {
      if (typeof query.state !== 'string') {
        delete query.state;
      }
    }

    // Pipe delimit categories for URL encoding
    if (_.isArray(query.category_code) && query.category_code.length) {
      query.category_code = query.category_code.map(s => (typeof s === 'object' ? s.category : s)).join('|');
    } else {
      if (typeof query.category_code !== 'string') {
        delete query.category_code;
      }
    }

    // sanitize keys used for UI only
    ['total', 'current'].forEach(key => {
      if (key in query) {
        delete query[key];
      }
    });
    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(`${this.API_URL}/admin/completedorders${queryString}`, {
      loadingText: 'Loading Visits',
    });
  }
  searchMailOrder(pagination) {
    // Create a clone so we aren't modifying the pagination object associated with the view
    const query = Object.assign({}, pagination);
    query.start_time = _.isDate(query.start_time) ? moment(query.start_time).toISOString() : undefined;

    // We need to add a day to endtime so we get all orders for the day selected
    query.end_time = _.isDate(query.end_time) ? moment(query.end_time).add(1, 'day').toISOString() : undefined;
    if (query.status === 'all') {
      delete query['status'];
    }

    // // sanitize keys used for UI only
    // ['total', 'current'].forEach((key) => {
    //   if (key in query) {
    //     delete query[key];
    //   }
    // });

    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(`${this.API_URL}/admin/fillrequests${queryString}`, {
      loadingText: 'Loading Visits',
    });
  }
  searchLemonaidPharmacyMailorder(pagination) {
    // Create a clone so we aren't modifying the pagination object associated with the view
    const query = Object.assign({}, pagination);
    if (_.isArray(query.state) && query.state.length) {
      query.state = query.state.map(s => (typeof s === 'object' ? s.code : s)).join('|');
    } else {
      if (typeof query.state !== 'string') {
        delete query.state;
      }
    }
    if (query.status === 'all') {
      // As Maksim requested
      // it's ok to show 'cancelled' but please remove 'incomplete', it's payment status
      // As Greg confirmed
      // User should not be able to filter by "open"
      // So finally, we removed "open" and "incomplete" from "all statuses" (default)

      // delete query["status"];
      query.status = 'in-progress|on-hold|cancelled|delivered|error|ordered|sent|shipped';
    }
    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(this.Endpoints.orders.lemonaidPharmacyMailorderSearch + queryString, {
      loadingText: 'Loading Visits',
    });
  }
  searchOutboundCallVisit(pagination) {
    // Create a clone so we aren't modifying the pagination object associated with the view
    const query = Object.assign({}, pagination);
    if (_.isArray(query.state) && query.state.length) {
      query.state = query.state.map(s => (typeof s === 'object' ? s.code : s)).join('|');
    } else {
      if (typeof query.state !== 'string') {
        delete query.state;
      }
    }
    if (query.status === 'all') {
      query.status = 'call_needed|left_message|call_completed|follow_up';
    }
    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(this.Endpoints.outboundVisit.baseGet + queryString, {
      loadingText: 'Loading Visits',
    });
  }
  updateOutboundCallVisit(id, payload) {
    return this.$http.put(this.Endpoints.outboundVisit.updateCallStatus.replace(':id', id), payload);
  }
  searchScanwellMatching(pagination) {
    // Create a clone so we aren't modifying the pagination object associated with the view
    const query = Object.assign({}, pagination);

    // FOR status PARAMETER
    if (query.status === 'all') {
      delete query['status'];
    }

    // sanitize keys used for UI only
    ['total', 'current'].forEach(key => {
      if (key in query) {
        delete query[key];
      }
    });
    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(this.Endpoints.scanwellMatching.search + queryString, {
      loadingText: 'Loading Test Results',
    });
  }
  searchScanwellResults(pagination) {
    // Create a clone so we aren't modifying the pagination object associated with the view
    const query = Object.assign({}, pagination);

    // Pipe delimit states for URL encoding
    if (_.isArray(query.state) && query.state.length) {
      query.state = query.state.map(s => (typeof s === 'object' ? s.code : s)).join('|');
    } else {
      if (typeof query.state !== 'string') {
        delete query.state;
      }
    }

    // FOR reviewed PARAMETER
    if (query.reviewed === 'all') {
      delete query['reviewed'];
    }

    // FOR locked PARAMETER
    if (query.locked === 'all') {
      delete query['locked'];
    }

    // FOR lock_records PARAMETER
    // We convert from boolean to string
    if (query.lock_records) {
      query.lock_records = 'true';
    } else {
      query.lock_records = 'false';
    }

    // sanitize keys used for UI only
    ['total', 'current'].forEach(key => {
      if (key in query) {
        delete query[key];
      }
    });
    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(this.Endpoints.scanwellResults.search + queryString, {
      loadingText: 'Loading Test Results',
    });
  }
  searchScanwellShipping(pagination) {
    // Create a clone so we aren't modifying the pagination object associated with the view
    const query = Object.assign({}, pagination);

    // Pipe delimit admin statuses for URL encoding
    if (_.isArray(query.status) && query.status.length) {
      query.status = query.status.map(s => (typeof s === 'object' ? s.type : s)).join('|');
    } else {
      if (typeof query.status !== 'string') {
        delete query.status;
      }
    }

    // Pipe delimit states for URL encoding
    if (_.isArray(query.state) && query.state.length) {
      query.state = query.state.map(s => (typeof s === 'object' ? s.code : s)).join('|');
    } else {
      if (typeof query.state !== 'string') {
        delete query.state;
      }
    }

    // sanitize keys used for UI only
    ['total', 'current'].forEach(key => {
      if (key in query) {
        delete query[key];
      }
    });
    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(this.Endpoints.scanwellShipping.search + queryString, {
      loadingText: 'Loading Visits',
    });
  }
  getTreatmentPlans(order_id) {
    return this.$http.get(this.Endpoints.orders.getTreatmentPlans.replace(':id', order_id));
  }
  saveTreatmentPlans(order_id, prescription_id, message_template) {
    return this.$http.put(
      this.Endpoints.orders.saveTreatmentPlans.replace(':id', order_id).replace(':prescription_id', prescription_id),
      {
        message_template: message_template,
      },
    );
  }
  getLemonaidPharmacyMailorder(id) {
    return this.$http.get(this.Endpoints.orders.lemonaidPharmacyMailorderOne.replace(':id', id));
  }
  updateLemonaidPharmacyMailorder(id, payload) {
    return this.$http.put(this.Endpoints.orders.lemonaidPharmacyMailorderOne.replace(':id', id), payload);
  }
  getScanwellMatchingDetails(id) {
    return this.$http.get(this.Endpoints.scanwellMatching.one.replace(':id', id));
  }
  updateScanwellMatchingDetails(id, payload) {
    return this.$http.put(this.Endpoints.scanwellMatching.one.replace(':id', id), payload);
  }
  getScanwellResultsByOrderId(order_id) {
    return this.$http.get(this.Endpoints.scanwellResults.byOrderId.replace(':order_id', order_id));
  }
  getScanwellResultsDetails(id) {
    return this.$http.get(this.Endpoints.scanwellResults.one.replace(':id', id));
  }
  updateScanwellResultsDetails(id, payload) {
    return this.$http.put(this.Endpoints.scanwellResults.one.replace(':id', id), payload);
  }
  getScanwellShippingDetails(order_id, order_lab_id) {
    return this.$http.get(
      this.Endpoints.scanwellShipping.one.replace(':order_id', order_id).replace(':order_lab_id', order_lab_id),
    );
  }
  updateScanwellShippingDetails(order_id, order_lab_id, payload) {
    return this.$http.put(
      this.Endpoints.scanwellShipping.one.replace(':order_id', order_id).replace(':order_lab_id', order_lab_id),
      payload,
    );
  }
  getMailOrderHistory(id) {
    return this.$http.get(this.Endpoints.orders.getMailOrderHistory.replace(':id', id));
  }
  updateMailOrderStatus(mail_order_id, fill_request_id) {
    return this.$http.put(
      this.Endpoints.orders.updateMailOrderStatus.replace(':id', mail_order_id).replace(':frid', fill_request_id),
    );
  }

  getBatchableVisitsPaginated(pagination) {
    const { AdminStatuses } = this.Constants;

    const defaults = {
      has_default_med: true,
      is_new_patient: true,
      include_all_blocked: false,
      has_med_history: false,
      category_code: 'CP',
      answer_status: 'Normal',
      admin_status: [AdminStatuses.PaymentReceived.NumericValue, AdminStatuses.MultiPhotoApproved.NumericValue],
      fraud_match_count: 0,
      real_user_message_count: 0,
      is_slv: false,
    };
    return this.search(Object.assign({}, defaults, pagination), false, true);
  }
  getRejectionReasons(type = null) {
    let parameters = '';
    if (type) {
      parameters = '?type=' + type;
    }
    return this.$http.get(this.Endpoints.orders.rejectionReasons + parameters, {
      cache: true,
      loadingText: 'Loading Rejection Reasons',
    });
  }
  getOne(id, isPolling) {
    return this.$http.get(`${this.API_URL}/admin/orders/${id}${isPolling ? '?polling=true' : ''}`);
  }
  updatePharmacyOption(id, payload) {
    return this.$http.put(this.Endpoints.orders.detail.replace(':id', id), payload);
  }
  getQueueVisit(id, isPolling) {
    return this.$http.get(`${this.API_URL}/admin/orders/${id}/queueentries/current${isPolling ? '?polling=true' : ''}`);
  }

  lock(id = this.current.id, polling = false) {
    // JUST FOR QA TESTING
    // this.toastr.info('Visit locked ('+this.current.id+')');
    if (polling) {
      return this.$http.post(this.Endpoints.orders.lock.replace(':id', id) + "?polling=true");
    } else {
      return this.$http.post(this.Endpoints.orders.lock.replace(':id', id), null, {
        loadingText: 'Locking Visit',
      });
    }
  }

  unlock(id = this.current.id) {
    // JUST FOR QA TESTING
    // this.toastr.info('Visit unlocked ('+this.current.id+')');
    return this.$http.delete(this.Endpoints.orders.lock.replace(':id', id) + '?polling', {
      loadingText: 'Unlocking Visit',
    });
  }

  async unlockWithKeepAlive(id = this.current.id) {
    const token = window.localStorage.getItem('token');
    const body = { action: 'DELETE' };
    const config = this.BODACDC_625
      ? {
        keepalive: true,
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
      : {
        keepalive: true,
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      };

    await fetch(this.Endpoints.orders.lockAsPostApi.replace(':id', id) + '?polling', {
      ...config,
      body: JSON.stringify(body),
    });
  }

  deny(message, rejection_reason_id) {
    return this.$http.post(
      this.Endpoints.orders.deny.replace(':id', this.current.id),
      {
        message,
        rejection_reason_id,
      },
      {
        loadingText: 'Denying Visit',
      },
    );
  }
  denyByPST(message, rejection_reason_id) {
    return this.$http.post(
      this.Endpoints.orders.denyByPST.replace(':id', this.current.id),
      {
        message,
        rejection_reason_id,
      },
      {
        loadingText: 'Denying Visit',
      },
    );
  }
  flag(payload) {
    return this.$http.put(this.Endpoints.orders.flags.replace(':id', this.current.id), payload);
  }
  getFlagDetails(id, flag) {
    return this.$http.get(this.Endpoints.orders.flagDetails.replace(':id', id).replace(':flag', flag));
  }

  /*
  =============================================================================
  Notes
  =============================================================================
  */
  getNotes() {
    return this.$http.get(this.Endpoints.orders.notes.replace(':id', this.current.id));
  }

  // { note: "hello bob" }
  postNote(note) {
    return this.$http.post(this.Endpoints.orders.notes.replace(':id', this.current.id), {
      note,
    });
  }

  /*
  =============================================================================
  Review NP Vists
  =============================================================================
  */
  getReviewedNPVisit(id) {
    return this.$http.get(this.Endpoints.review.NPVisit.replace(':id', id));
  }

  // { note: "hello bob" }
  postReviewNPVisit(review_notes) {
    return this.$http.post(this.Endpoints.review.NPVisit.replace(':id', this.current.id), {
      review_notes: review_notes,
    });
  }

  /*
  =============================================================================
  Video Calls
  =============================================================================
  */

  getVideoCalls(id) {
    return this.$http.get(this.Endpoints.orders.videocalls.replace(':id', id) + '?polling=true');
  }

  /*
  =============================================================================
  Phone Calls
  =============================================================================
  */

  getPhoneCalls(id) {
    return this.$http.get(this.Endpoints.orders.phonecalls.replace(':id', id) + '?polling=true');
  }

  /*
  =============================================================================
  Phone Call Bookings
  =============================================================================
  */

  getCallBookingByOrderId(orderId, timezone = null) {
    let parameters = '';
    if (timezone) {
      parameters = '?timezone=' + timezone;
    }
    return this.$http.get(this.Endpoints.orders.getCallBooking.replace(':id', orderId) + parameters);
  }
  getCallBookingDates(schedule_code, timezone = null, order_id = null, start_date = null, num_days = null) {
    let parameters = '';
    if (timezone) {
      parameters = '?timezone=' + timezone;
      if (order_id) parameters = parameters + '&order_id=' + order_id;
      if (start_date) parameters = parameters + '&start_date=' + start_date;
      if (num_days) parameters = parameters + '&num_days=' + num_days;
    }
    return this.$http.get(this.Endpoints.callBookings.getDates.replace(':schedule_code', schedule_code) + parameters, {
      loadingText: 'Loading Booking Dates',
    });
  }
  getCallBookingTimes(schedule_code, date, timezone = null) {
    let parameters = '';
    if (timezone) {
      parameters = '?timezone=' + timezone;
    }
    return this.$http.get(
      this.Endpoints.callBookings.getTimes.replace(':schedule_code', schedule_code).replace(':date', date) + parameters,
      {
        loadingText: 'Loading Booking Times',
      },
    );
  }
  createCallBooking(order_id, start_time, timezone, schedule_code) {
    let payload = {
      order_id: order_id,
      start_time: start_time,
      timezone: timezone,
    };
    return this.$http.post(this.Endpoints.callBookings.create.replace(':schedule_code', schedule_code), payload);
  }
  deleteCallBooking(call_booking_id, schedule_code) {
    return this.$http.delete(
      this.Endpoints.callBookings.delete.replace(':schedule_code', schedule_code).replace(':id', call_booking_id),
    );
  }

  /*
  =============================================================================
  Labs
  =============================================================================
  */

  sendOrderLab(id) {
    return this.$http.post(this.Endpoints.orders.sendLabs.replace(':id', id), {});
  }
  getOrderLab(user_id, id) {
    return this.$http.get(this.Endpoints.orders.getLabs.replace(':user_id', user_id).replace(':id', id), {
      responseType: 'arraybuffer',
    });
  }
  getPartnerLabs(visit_id) {
    return this.$http.get(this.Endpoints.partnerUsers.getPartnerLabs.replace(':visit_id', visit_id));
  }

  /*
      getOrderLab(user_id,id) {
        return this.$http.get(
          this.Endpoints.orders.getLabs.replace(':user_id',user_id).replace(':id', id),
          {  }
        );
      }
  */

  /*
  =============================================================================
  Questionnaire
  =============================================================================
  */
  getResponses(visitId) {
    return this.$http.get(`${this.API_URL}/admin/orders/${visitId || this.current.id}/responses`);
  }

  /*
  =============================================================================
  Rx Hub
  =============================================================================
   */
  getRxhubIntegrations(pagination) {
    const query = this.Utils.serializeQuery(pagination);
    return this.$http.get(`${this.API_URL}/prxhub/integrations${query}`);
  }

  unsubscribeFromLegaldoc(dispense_order_id, order_id) {
    return this.$http.put(
      `${this.API_URL}/prxhub/dispenseorders/${dispense_order_id}/orders/${order_id}/silencealert/legaldoc`,
    );
  }
  unsubscribeFromO2D(dispense_order_id, order_id) {
    return this.$http.put(
      `${this.API_URL}/prxhub/dispenseorders/${dispense_order_id}/orders/${order_id}/silencealert/o2d`,
    );
  }
  unsubscribeFromO2dSent(dispense_order_id, order_id) {
    return this.$http.put(
      `${this.API_URL}/prxhub/dispenseorders/${dispense_order_id}/orders/${order_id}/silencealert/sent`,
    );
  }
  /*
  =============================================================================
  Photos
  =============================================================================
  */
  getPhotos(visitId) {
    return this.$http.get(`${this.API_URL}/admin/orders/${visitId || this.current.id}/photos?polling=true`);
  }

  // {
  //     "approved": true/false,
  //     "photo_ids": [1,2,3], ** only rejection
  //     "rejection_message": "string", ** only rejection
  //     "diagnosis": "string"
  // }
  setPhotos(visitId, status) {
    return this.$http.post(`${this.API_URL}/admin/orders/${visitId}/photos`, status);
  }
  getIdPhotos(visitId) {
    return this.$http.get(`${this.API_URL}/admin/orders/${visitId || this.current.id}/idphotos?polling=true`);
  }

  /**
   * Approving photos
   *
   * {
   *     "reviews": [
   *         {
   *             "file_id": 14,
   *             "approved": true,
   *             "notes": "Internal notes that patient does not see"
   *         },
   *         {
   *             "file_id": 15,
   *             "approved": true,
   *             "notes": "Internal notes that patient does not see"
   *         }
   *     ]
   * }
   * Rejecting photos
   *
   * {
   *     "reviews": [
   *         {
   *             "file_id": 15,
   *             "approved": false,
   *             "notes": null,
   *             "rejection_note": "Note to patient asking them to re-take"
   *         }
   * }
   * @param visitId
   * @param status
   * @returns {void|*}
   */
  setIdPhotos(visitId, status) {
    return this.$http.post(`${this.API_URL}/admin/orders/${visitId}/idphotos/reviews`, status);
  }
  setIdPhotosNew(visitId, status): Observable<any> {
    return from(this.$http.post(`${this.API_URL}/admin/orders/${visitId}/idphotos/reviews`, status));
  }
  getExamPhotos(visitId) {
    return this.$http.get(`${this.API_URL}/admin/orders/${visitId || this.current.id}/visitphotos?polling=true`);
  }

  /**
   * Approving photos
   *
   * {
   *     "reviews": [
   *         {
   *             "file_id": 14,
   *             "approved": true,
   *             "notes": "Internal notes that patient does not see"
   *         },
   *         {
   *             "file_id": 15,
   *             "approved": true,
   *             "notes": "Internal notes that patient does not see"
   *         }
   *     ]
   * }
   * Rejecting photos
   *
   * {
   *     "reviews": [
   *         {
   *             "file_id": 15,
   *             "approved": false,
   *             "notes": null,
   *             "rejection_note": "Note to patient asking them to re-take"
   *         }
   * }
   * @param visitId
   * @param status
   * @returns {void|*}
   */
  setExamPhotos(visitId, status) {
    return this.$http.post(`${this.API_URL}/admin/orders/${visitId}/visitphotos/reviews`, status);
  }
  approveLabs(visitId, status) {
    return this.$http.put(`${this.API_URL}/tasks/${visitId}/status`, status);
  }

  /**
   * Checks to see if a specific visit is pre-screened.
   * This is used right before a prescreened order is processed.  The doctor
   * chooses to prescribe to patients on the prescreened page and for each order
   * we check to see if the order is still pre-screened before doing all the
   * prescription work.
   * @param {number} visitId - id of order to add treatments to
   * @returns {promise} 200 - will have data true or false.
   *
   * treatments: [{
   *  medication_id: 1
   *  short_directions: "Take with beer.",
   *  dispense_amount: 40,
   *  num_refills: 30,
   *  pharmacy_notes: "Hey pharmacy, you're looking good tonight.",
   *  no_substitions: true // if patient is adamant about their chosen prescription
   * }]
   *
   */
  isPrescreened(visitId) {
    return this.$http.get(`${this.API_URL}/admin/orders/${visitId}/prescreened`);
  }

  /**
   * Adds prescriptions to a visit
   * @param {number} visitId - id of order to add treatments to
   * @param {array} treatments - array of treatment objects, see below for structure
   * @returns {void} 200
   *
   * prescriptions: [{
   *  medication_id: 1
   *  short_directions: "Take with beer.",
   *  dispense_amount: 40,
   *  num_refills: 30,
   *  pharmacy_notes: "Hey pharmacy, you're looking good tonight.",
   *  no_substitions: true, // if patient is adamant about their chosen prescription
   *  pharmacy_id: 123
   * }]
   *
   */

  putPrescriptions(visitId, medications) {
    if (!Array.isArray(medications) || !medications.length) {
      throw new Error('Medications must be an array with a length.');
    }
    return this.$http.put(this.Endpoints.orders.updatePrescriptions.replace(':id', visitId), {
      prescriptions: medications.map(m => this.MedicationService.formatMedication(m)),
    });
  }

  bundlePrescriptions(visitId) {
    return this.$http.put(this.Endpoints.orders.updatePrescriptions.replace(':id', visitId), { prescriptions: [] });
  }

  /**
   * Clear prescriptions for a visit
   *
   * We call this endpoint only when:
   * 1) Visit has never been completed
   * 2) Doctor is changing the pharmacy option
   */

  // emptyPrescriptions(visitId) {
  //   var payload = {
  //     prescriptions: []
  //   }

  //   return this.$http.put(this.Endpoints.orders.updatePrescriptions.replace(':id', visitId), payload);
  // }

  /**
   * Adds treatments to a visit
   * @param {number} visitId - id of order to add treatments to
   * @param {array} treatments - array of treatment objects, see below for structure
   * @returns {void} 200
   *
   * treatments: [{
   *  medication_id: 1
   *  short_directions: "Take with beer.",
   *  dispense_amount: 40,
   *  num_refills: 30,
   *  pharmacy_notes: "Hey pharmacy, you're looking good tonight.",
   *  no_substitions: true // if patient is adamant about their chosen prescription
   * }]
   *
   */

  // postMedications(visitId, medications) {
  //   if (!Array.isArray(medications) || !medications.length) {
  //     throw new Error('Medications must be an array with a length.');
  //   }

  //   return this.$http.post(
  //     `${this.API_URL}/admin/orders/${visitId}/treatment`,
  //     {
  //       treatments: medications.map(
  //         m => this.MedicationService.formatMedication(m)
  //       ),
  //     }
  //   );
  // }

  /*
  =============================================================================
  Prescriptions
  =============================================================================
  */

  getRxHistory(id, pagination) {
    // Create a clone so we aren't modifying the pagination object associated with the view
    const query = Object.assign({}, pagination);

    // sanitize keys used for UI only
    ['total', 'current'].forEach(key => {
      if (key in query) {
        delete query[key];
      }
    });
    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(`${this.API_URL}/admin/users/${id}/prescriptions${queryString}`, {
      loadingText: 'Loading Rx History',
    });
  }
  getUserAllergy(id) {
    // return this.$http.get(
    //   this.Endpoints.dosespot.userAllergy.replace(':id', id),
    //   { loadingText: 'Loading Allergies' }
    // );

    return this.$http.get(this.Endpoints.dosespot.userAllergy.replace(':id', id));
  }
  getPrescriptions() {
    return this.$http.get(this.Endpoints.orders.finalize.replace(':id', this.current.id), {
      loadingText: 'Loading Prescriptions',
    });
  }
  createDosespotRequest(payload) {
    return this.$http.post(`${this.API_URL}/admin/dosespot/requests`, payload);
  }
  createPrescription(visitId) {
    return this.createDosespotRequest({
      type: 'create_prescriptions',
      order_id: visitId,
    });
  }
  sendPrescription(visitId) {
    return this.createDosespotRequest({
      type: 'send_prescriptions',
      order_id: visitId,
    });
  }
  getPrescriptionStatus(dosespotPrescriptionId) {
    return this.createDosespotRequest({
      type: 'get_prescription_log',
      dosespot_prescription_id: dosespotPrescriptionId,
    });
  }

  // THIS IS JUST FOR TESTING
  // HOTFIX 127
  getPrescriptionStatus_Fake(dosespotPrescriptionId) {
    var this2 = this;
    console.log('Calling Dosespot Fake API');
    return new Promise((resolve, reject) => {
      let data = {
        data: {
          latest_status: null,
          entries: [],
        },
      };
      this2.$timeout(() => {
        resolve(data);
      }, 10000);
    });
  }
  updateTransmissionError(transmissionErrorId, type) {
    if (type !== 'ignore' && type !== 'print') {
      throw new Error(`${type} is not a supported type.`);
    }
    if (typeof transmissionErrorId !== 'number') {
      throw new Error('TranmissionErrorId must be a number.');
    }
    return this.createDosespotRequest({
      type: 'put_transmission_error',
      dosespot_transmission_error_id: transmissionErrorId,
      acknowledgment_type: type,
    });
  }
  completeVisit(visitId) {
    return this.$http.post(`${this.API_URL}/admin/orders/${visitId}/finalise`);
  }

  nonMedPayment(order_id, medicationPayment) {
    return this.$http.post(this.Endpoints.orders.nonMedPayments.replace(':id', order_id), medicationPayment);
  }
  // Step 1: If any medications don't have a dosespot_prescription_id, create the prescriptions
  // Step 2: If any of the medications don't have a sent timestamp, send the prescriptions
  // Step 3: If the visit is not yet in the complete state, complete the visit to
  //         send off notifications
  // Step 4: Pull down the updated visit entity
  performCompletionSeries(visit) {
    if (!visit.order_lines || !Array.isArray(visit.order_lines)) {
      throw new Error('Order needs an order line');
    }
    let needsCreating = false;
    let needsSending = false;
    const promises = [];
    // const medications = visit.order_lines[0].medications;
    const medications = visit.prescriptions;

    // COMMENTED FOR BOOTS
    //
    // medications.forEach((m) => {
    //   if (!m.dosespot_prescription_id) {
    //     needsCreating = true;
    //   }
    //   if (!m.sent) {
    //     needsSending = true;
    //   }
    // });

    // if (needsCreating) {
    //   promises.push(this.createPrescription.bind(this, visit.id));
    // }

    // if (needsSending) {
    //   promises.push(this.sendPrescription.bind(this, visit.id));
    // }

    // WE CREATED THIS SWITCH FOR TESTING
    // TO REPRODUCE THE SCENARIO WHEN ONE VISIT IS LEFT OPEN
    // WHEN PRESCRIPTION WAS CREATED AND/OR SENT TO DOSESPOT
    // BUT VISIT WAS NOT FINALIZED FOR SOME REASON

    // NOTICE:
    // SWITCH MUST BE CHANGED ON 2 FILES:
    // prescribe.js
    // order.service.js (this file)

    var makingVisitLeftOpenAndNotFinalized = false;
    if (!makingVisitLeftOpenAndNotFinalized) {
      // NORMAL CODE
      if (visit.admin_status !== this.Constants.AdminStatuses.Complete.NumericValue) {
        promises.push(this.completeVisit.bind(this, visit.id));
      }
      promises.push(this.getOne.bind(this, visit.id));
    }
    return Promise.series(promises);
  }
  getCategories() {
    return this.$http.get(this.Endpoints.orders.categories);
  }
  checkMedicationPriceRequired(category_code) {
    var response = 0;
    var categories = this.localStorageService.get('all_categories');
    if (!categories || !categories.length) return response;
    categories.forEach(category => {
      if (category.code === category_code) {
        response = category.medication_charge_required;
      }
    });
    return response;
  }

  /*
  =============================================================================
  Mailorder
  =============================================================================
  */

  cancelMailorder(mail_order_id, data) {
    return this.$http.put(this.Endpoints.mailorder.cancelMailorder.replace(':id', mail_order_id), data);
  }
  reprocessFillRequest(mail_order_id, mail_order_fill_request_id, reprocessPayment, reprocessFillRequest) {
    var payload = {
      process_payment: reprocessPayment,
      process_fill_request: reprocessFillRequest,
    };
    return this.$http.put(
      this.Endpoints.mailorder.reprocessFillRequest
        .replace(':mail_order_id', mail_order_id)
        .replace(':mail_order_fill_request_id', mail_order_fill_request_id),
      payload,
    );
  }
  updateMailOrderPrescriptionPharmacy(mail_order_id, prescription_id, pharmacy_id) {
    var payload = {
      pharmacy_id: pharmacy_id,
    };
    return this.$http.put(
      this.Endpoints.mailorder.updateMailOrderPharmacy
        .replace(':mail_order_id', mail_order_id)
        .replace(':prescription_id', prescription_id),
      payload,
    );
  }
  getMailOrderDetails(id) {
    return this.$http.get(this.Endpoints.mailorder.mailorderDetails.replace(':id', id));
  }
  sendRefills(refillsData) {
    return this.$http.post(this.Endpoints.mailorder.sendRefills, refillsData);
  }
  updateRefills(fill_request_id, refillsData) {
    return this.$http.put(
      this.Endpoints.mailorder.updateRefills.replace(':fill_request_id', fill_request_id),
      refillsData,
    );
  }
  getRefillsData(order_line_medication_id) {
    return this.$http.get(
      this.Endpoints.mailorder.refillsData.replace(':order_line_medication_id', order_line_medication_id),
    );
  }
  getRecalculatedPrice(order_id) {
    return this.$http.get(
      this.Endpoints.orders.getRecalculatedRefillPrice.replace(':orderId', order_id),
    );
  }
  sendTransferRequests(transferrequests) {
    return this.$http.post(this.Endpoints.mailorder.sendTransferRequests, transferrequests);
  }
  mailorderChargeCompleteVisit(id, chargeData) {
    return this.$http.post(this.Endpoints.mailorder.mailorderChargeCompleteVisit.replace(':id', id), chargeData);
  }
  mailorderChargeRefill(mail_order_id, chargeData) {
    return this.$http.post(
      this.Endpoints.mailorder.mailorderChargeRefill.replace(':mail_order_id', mail_order_id),
      chargeData,
    );
  }
  getRefillInfo(mail_order_id) {
    return this.$http.get(this.Endpoints.mailorder.getRefillInfo.replace(':mail_order_id', mail_order_id));
  }
  updateRefillInfo(mail_order_id, refillInfoObject) {
    return this.$http.put(
      this.Endpoints.mailorder.updateRefillInfo.replace(':mail_order_id', mail_order_id),
      refillInfoObject,
    );
  }
  slackNotification(SlackData, env_check, partner_code) {
    if (partner_code == 'Lemonaid') {
      if (env_check === 'production') {
        return this.$http.post(this.Endpoints.slackNotifications.lemonaidVisitProduction, SlackData);
      } else {
        return this.$http.post(this.Endpoints.slackNotifications.lemonaidVisitTest, SlackData);
      }
    } else {
      if (env_check === 'production') {
        return this.$http.post(this.Endpoints.slackNotifications.completeVisitProduction, SlackData);
      } else {
        return this.$http.post(this.Endpoints.slackNotifications.completeVisitTest, SlackData);
      }
    }
  }
  updateMailorderDeliveryType(mail_order_id, mailorderType) {
    return this.$http.put(
      this.Endpoints.mailorder.mailorderDeliveryType.replace(':mail_order_id', mail_order_id),
      mailorderType,
    );
  }
  createMailorderFill(mail_order_id) {
    return this.$http.post(this.Endpoints.mailorder.createFill.replace(':id', mail_order_id));
  }
  updateMailorderFill(mail_order_id, fill_id, fillDetail) {
    return this.$http.put(
      this.Endpoints.mailorder.updateFill.replace(':id', mail_order_id).replace(':fid', fill_id),
      fillDetail,
    );
  }
  chargeMedication(order_id, medicationPayment) {
    return this.$http.post(this.Endpoints.orders.payment.replace(':id', order_id), medicationPayment);
  }
  mailorderFillPayment(mail_order_id, fill_id, medicationPayment) {
    return this.$http.post(
      this.Endpoints.mailorder.FillPayment.replace(':id', mail_order_id).replace(':fid', fill_id),
      medicationPayment,
    );
  }
  mailorderFillProcess(mail_order_id, fill_id) {
    return this.$http.post(this.Endpoints.mailorder.fillProcess.replace(':id', mail_order_id).replace(':fid', fill_id));
  }
  deleteFillRequest(mail_order_id, fill_id) {
    return this.$http.delete(
      this.Endpoints.mailorder.deleteFillRequest.replace(':mail_order_id', mail_order_id).replace(':fill_id', fill_id),
    );
  }

  /*
  =============================================================================
  Test Kit QR Codes
  =============================================================================
  */

  getOrderTestKitsQR(id) {
    return this.$http.get(this.Endpoints.orders.getOrderTestKitsQR.replace(':id', id));
  }
  createOrderTestKitsQR(id) {
    return this.$http.post(this.Endpoints.orders.createOrderTestKitsQR.replace(':id', id));
  }
  getTestKitQR(id, testKitId) {
    return this.$http.get(this.Endpoints.orders.getTestKitQR.replace(':id', id).replace(':tkid', testKitId));
  }
  createTestKitQR(id, testKitId) {
    return this.$http.post(this.Endpoints.orders.createTestKitQR.replace(':id', id).replace(':tkid', testKitId));
  }

  /*
  =============================================================================
  Tasks
  =============================================================================
  */

  _getTasksFromStage(visit, stage) {
    let tasks = [];
    if (!_.isEmpty(visit)) {
      tasks = visit.order_lines[0].stages[stage].tasks;
    }
    return tasks;
  }
  getTaskByType(taskType, visit, stage) {
    const task = _.filter(this._getTasksFromStage(visit, stage), {
      type: taskType,
    })[0];
    return task;
  }
  updateTask(taskId, status) {
    return this.$http.put(this.Endpoints.tasks.status.replace(':id', taskId), {
      value: status,
    });
  }
  updatePhoneCallCompleted(id) {
    return this.$http.put(this.Endpoints.tasks.callCompleted.replace(':id', id));
  }

  /*
  =============================================================================
  Pharmacies
  =============================================================================
  */

  getPharmacies() {
    return this.$http.get(this.Endpoints.pharmacies.search, {
      loadingText: 'Loading Pharmacies',
    });
  }
  updatePharmacy(pharmacy) {
    const payload = {
      type: 'pharmacy',
      id: pharmacy.id,
    };
    return this.$http.put(`${this.API_URL}/admin/orders/${this.current.id}/delivery`, payload);
  }

  /**
   * Returns an array of alerts based on the visit and patient
   * @param  {object} questionnaire - questionnaire q&a
   * @param  {object} patient  - patient who filled out questionnaire
   * @return {array} array of alert objects
   */
  getQuestionnaireAlerts(questionnaire, patient) {
    const alerts = [];
    const patientAge = this.$filter('age')(patient.dob);
    const { code: serviceCode } = questionnaire;
    var thePatientSmokes = null;
    var smokingQuestion = null;
    var thePatientHasMigraines = null;
    var migraineQuestion = null;
    var thePatientHasBloodInUrine = null;
    var bloodUrineQuestion = null;
    try {
      const { answers } = questionnaire;
      var pimsParameters = this.localStorageService.get('pimsParameters');

      // if (serviceCode === 'CP') {
      if (
        pimsParameters &&
        pimsParameters.pimsAnswerAlertCategories &&
        pimsParameters.pimsAnswerAlertCategories.answer_smoke_migraine &&
        pimsParameters.pimsAnswerAlertCategories.answer_smoke_migraine.length &&
        pimsParameters.pimsAnswerAlertCategories.answer_smoke_migraine.indexOf(serviceCode) > -1
      ) {
        console.log('Checking smoking / migraine for ' + serviceCode);

        // We improved this code to not fail when the question has no the expected text,
        // for example using different questionnaire
        // We just check the answer if we find the question we are searching for
        // Otherwise code breaks
        thePatientSmokes = null;
        smokingQuestion = _.find(answers, response => response.question.text.includes("It's not always appropriate"));
        if (smokingQuestion) {
          thePatientSmokes = _.find(smokingQuestion.value, answer => answer.text.includes('Smoke cigarettes'));
        }
        thePatientHasMigraines = null;
        migraineQuestion = _.find(answers, response => response.question.text.includes('Migraine headaches'));
        if (migraineQuestion) {
          thePatientHasMigraines = _.find(migraineQuestion.value, answer =>
            answer.text.includes('Migraine headaches without'),
          );
        }
        if (patientAge >= 35) {
          if (thePatientSmokes) {
            alerts.push({
              type: 'warning',
              title: 'Progestin Only',
              text: `Patient is older than 35 and the patient ${thePatientSmokes ? 'smokes.' : 'has migraines.'}`,
            });
          }
        }
        // else if (thePatientSmokes) {
        //   alerts.push({
        //     type: 'warning',
        //     title: 'Warning: Patient smokes',
        //     text: 'Consider counselling about adverse effects.',
        //   });
        // }
      }

      // if (serviceCode === 'ED' || serviceCode === 'EDX' || serviceCode === 'EDA' || serviceCode === 'PE') {
      if (
        pimsParameters &&
        pimsParameters.pimsAnswerAlertCategories &&
        pimsParameters.pimsAnswerAlertCategories.answer_smoke_cigarettes &&
        pimsParameters.pimsAnswerAlertCategories.answer_smoke_cigarettes.length &&
        pimsParameters.pimsAnswerAlertCategories.answer_smoke_cigarettes.indexOf(serviceCode) > -1
      ) {
        console.log('Checking smoking for ' + serviceCode);

        // We improved this code to not fail when the question has no the expected text,
        // for example using different questionnaire
        // We just check the answer if we find the question we are searching for
        // Otherwise code breaks
        thePatientSmokes = null;
        smokingQuestion = _.find(answers, response => response.question.text.includes('related to tobacco'));
        if (smokingQuestion) {
          thePatientSmokes = _.find(smokingQuestion.value, answer => answer.text.includes('Smoke cigarettes'));
        }
        if (thePatientSmokes) {
          alerts.push({
            type: 'warning',
            title: 'Warning: Patient smokes',
            text: 'Consider counselling about adverse effects.',
          });
        }
      }

      // if (serviceCode === 'UTI') {
      if (
        pimsParameters &&
        pimsParameters.pimsAnswerAlertCategories &&
        pimsParameters.pimsAnswerAlertCategories.answer_blood_urine &&
        pimsParameters.pimsAnswerAlertCategories.answer_blood_urine.length &&
        pimsParameters.pimsAnswerAlertCategories.answer_blood_urine.indexOf(serviceCode) > -1
      ) {
        console.log('Checking urine for ' + serviceCode);

        // We improved this code to not fail when the question has no the expected text,
        // for example using different questionnaire
        // We just check the answer if we find the question we are searching for
        // Otherwise code breaks
        thePatientHasBloodInUrine = null;
        bloodUrineQuestion = _.find(answers, response => response.question.text.includes('blood in the urine'));
        if (!bloodUrineQuestion) {
          bloodUrineQuestion = _.find(answers, response => response.question.text.includes('Blood in the urine'));
        }
        if (bloodUrineQuestion) {
          thePatientHasBloodInUrine = _.find(bloodUrineQuestion.value, answer => answer.text.includes('Yes'));
        }
        if (patientAge >= 35 && thePatientHasBloodInUrine) {
          alerts.push({
            type: 'warning',
            title: 'Warning: Patient is 35 years or older with hematuria',
            text: `Suggest see doctor in person.`,
          });
        }

        /*
        // This was the previous early warning system (EWS) alert for UTI
        // We leave commented in case doctor wants it back in the future
        var firstQuestion = _.find(
          answers,
          response => response.question.text.includes('3 of these symptoms')
        );
        if (firstQuestion.value.length !== 3) {
          alerts.push({
            type: 'danger',
            title: 'Patient does not fit protocol',
            text: 'Patient did not answer YES to all three inclusion options.',
          });
        }
        */
      }
    } catch (e) {
      alerts.push({
        type: 'danger',
        title: 'Heads up',
        text: `Something went wrong creating the questionnaire alerts.
               Please <a href="mailto:support@lemonaidpims.co.uk">notify support</a>.`,
      });
    }
    return alerts;
  }
}

export const STATUSES = [
  { status: 'all', name: 'All Statuses' },
  { status: 0.1, name: 'Payment Received' },
  { status: 10, name: 'Complete' },
  { status: 2.5, name: 'Awaiting ID approval' },
  { status: 9.2, name: 'Admin Cancelled' },
  { status: 7.0, name: 'Lab Order Sent' },
  { status: 7.7, name: 'Lab Results Received' },
  { status: 0, name: 'New' },
  { status: 4.1, name: 'Questionnaire Submitted' },
  { status: 4.2, name: 'Delivery Address Submitted' },
  { status: 4.6, name: 'Id Photo Uploaded' },
  { status: 4.7, name: 'Id Photo Re-uploaded' },
  { status: 4.8, name: 'Exam Photo Uploaded' },
  { status: 4.9, name: 'Exam Photo Re-uploaded' },
  { status: 5.1, name: 'Medicine Prescribed' },
  { status: 5.4, name: 'Exam Photo Approved' },
  { status: 5.5, name: 'Exam Photo Rejected' },
  { status: 7.1, name: 'Remote Rx Created' },
  { status: 7.2, name: 'Remote Rx Sent' },
  { status: 8.1, name: 'Assessment Open' },
  { status: 8.2, name: 'Assessment Complete' },
  { status: 9.8, name: 'Expired' },
  { status: 9.9, name: 'User Cancelled' },
  { status: 2.1, name: 'Running patient history check' },
  { status: 4.4, name: 'Visit Photo Uploaded' },
  { status: 4.5, name: 'Visit Photo Re-uploaded' },
  { status: 2.4, name: 'Additional ID Photos Requested' },
  { status: 4.61, name: 'Additional ID Photos Uploaded' },
  { status: 5.71, name: 'Additional ID Photo Rejected' },
  { status: 4.71, name: 'Additional ID Photos Re-uploaded' },
  { status: 5.61, name: 'Additional ID Photos Approved' },
];

export const STATUS = {
  OPEN: 0,
  PENDING_REVIEW: 1,
  USER_CANCELLED: 2,
  APPROVED: 3,
  REJECTED: 4,
  CLOSED: 5,
};
export const TASKS = {
  QUESTIONNAIRE: 1,
  EXAM_VIDEO: 2,
  MULTI_PHOTO: 3,
  SMART_LIVE_VIDEO: 4,
  PAYMENT: 5,
  DELIVERY: 6,
  ASSIGN_AFFILIATE: 7,
  ASSIGN_EMR: 8,
  DISPATCH_TEST_KIT: 9,
  TEST_RESULTS: 10,
  PRESCRIBE_MEDICATION: 11,
  FINALISE: 12,
  CALLBACK: 13,
  ACCOUNT: 14,
  ID_PHOTO: 21,
  EXAM_PHOTO: 22,
};
export const TOTALFILLS = [
  {
    id: '1',
    name: '1 fill',
  },
  {
    id: '2',
    name: '2 fill',
  },
  {
    id: '3',
    name: '3 fill',
  },
  {
    id: '4',
    name: '4 fill',
  },
  {
    id: '5',
    name: '5 fill',
  },
  {
    id: '6',
    name: '6 fill',
  },
  {
    id: '7',
    name: '7 fill',
  },
  {
    id: '8',
    name: '8 fill',
  },
  {
    id: '9',
    name: '9 fill',
  },
  {
    id: '10',
    name: '10 fill',
  },
];
Orders.$inject = [
  'BaseService',
  '$filter',
  '$timeout',
  '$rootScope',
  'toastr',
  'ngDialog',
  'MedicationService',
  'Constants',
  'localStorageService',
  'Users',
  'ENV',
  'serverless_api_url',
];
